import { render, staticRenderFns } from "./NoticePdf.vue?vue&type=template&id=6d2d8524&scoped=true&"
import script from "./NoticePdf.vue?vue&type=script&lang=js&"
export * from "./NoticePdf.vue?vue&type=script&lang=js&"
import style0 from "./NoticePdf.vue?vue&type=style&index=0&id=6d2d8524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d8524",
  null
  
)

export default component.exports